<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="empresa"
                        :value="empresaSelected"
                        :options="empresaList"
                        :loading="empresaLoading"
                        @search="carregarEmpresa"
                        @input="updateEmpresa"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cidade"
                        :value="cidadeSelected"
                        :options="cidadeList"
                        :loading="cidadeLoading"
                        @search="carregarCidade"
                        @input="updateCidade"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="categoria"
                        :value="categoriaSelected"
                        :options="categoriaList"
                        :loading="categoriaLoading"
                        @search="carregarCategoria"
                        @input="updateCategoria"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="familia"
                        :value="familiaSelected"
                        :options="familiaList"
                        :loading="familiaLoading"
                        @search="carregarFamilia"
                        @input="updateFamilia"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="grupo"
                        :value="grupoSelected"
                        :options="grupoList"
                        :loading="grupoLoading"
                        @search="carregarGrupo"
                        @input="updateGrupo"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="subGrupoProduto"
                        :value="subGrupoProdutoSelected"
                        :options="subGrupoProdutoList"
                        :loading="subGrupoProdutoLoading"
                        @search="carregarSubGrupoProduto"
                        @input="updateSubGrupoProduto"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="produto"
                        :value="produtoSelected"
                        :options="produtoList"
                        :loading="produtoLoading"
                        @search="carregarProduto"
                        @input="updateProduto"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="unidadeMedida"
                        :value="unidadeMedidaSelected"
                        :options="unidadeMedidaList"
                        :loading="unidadeMedidaLoading"
                        @search="carregarUnidadeMedida"
                        @input="updateUnidadeMedida"
                        label="descricao"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{
                                selected && selected.length > 0
                                    ? selected.length
                                    : $t('todos')
                            }})
                        </template>
                    </vss-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            cidadeList: [],
            cidadeSelected: [],
            cidadeLoading: false,
            
            categoriaList: [],
            categoriaSelected: [],
            categoriaLoading: false,

            familiaList: [],
            familiaSelected: [],
            familiaLoading: false,
            
            grupoList: [],
            grupoSelected: [],
            grupoLoading: false,

            subGrupoProdutoList: [],
            subGrupoProdutoSelected: [],
            subGrupoProdutoLoading: false,

            produtoList: [],
            produtoSelected: [],
            produtoLoading: false,

            unidadeMedidaList: [],
            unidadeMedidaSelected: [],
            unidadeMedidaLoading: false,
        }
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        carregarEmpresa(searchQuery) {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa.json`, {
                    params: {
                        column: 'idempresa',
                        order: 'desc',
                        page: 0, 
                        limit: 200, 
                        situacao: 1,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaList = response.data.content.map((p) => {
                            return {
                                id: p.idempresa,
                                descricao: p.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;
            this.$emit('update-filtro', {
                nomeFiltro: 'idEmpresaList',
                valor:
                    this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((p) => p.id),
            })
        },
        carregarClientes(searchQuery) {
            this.clienteLoading = true;
            this.$axios
                .get(`/getcombo/cliente.json`, {
                    params: {
                        limit: 200,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar clientes.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.clienteList = response.data.content.map((c) => {
                            return {
                                id: c.idcliente,
                                descricao: c.rsocial
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.clienteList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar clientes.', e);
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            })
        },
        carregarCidade(searchQuery) {
            this.cidadeLoading = true;
            this.$axios
                .get(`/general/getcombo/city.json`, {
                    params: {
                        param: searchQuery,
                        situacao: 1,
                        limit: 200
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar cidades.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.cidadeList = response.data.content.map((p) => {
                            return {
                                id: p.idcidade,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.cidadeList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar cidades.', e);
                })
                .finally((_) => {
                    this.cidadeLoading = false;
                });
        },
        updateCidade(cidade) {
            this.cidadeSelected = cidade;
            this.$emit('update-filtro', {
                nomeFiltro: 'idCidadeList',
                valor:
                    this.cidadeSelected.length == 0 ? [] : this.cidadeSelected.map((p) => p.id),
            })
        },
        carregarCategoria(searchQuery) {
            this.categoriaLoading = true;
            this.$axios
                .get(`/vendas/categoria/getcombo.json`, {
                    params: {
                        situacao: 1,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar categorias.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.categoriaList = response.data.content.map((p) => {
                            return {
                                id: p.idcategoria,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.categoriaList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar categorias.', e);
                })
                .finally((_) => {
                    this.categoriaLoading = false;
                });
        },
        updateCategoria(categoria) {
            this.categoriaSelected = categoria;
            this.$emit('update-filtro', {
                nomeFiltro: 'idCategoriaList',
                valor:
                    this.categoriaSelected.length == 0 ? [] : this.categoriaSelected.map((p) => p.id),
            })
        },
        carregarFamilia(searchQuery) {
            this.familiaLoading = true;
            this.$axios
                .get(`/produtofamilia/list-combo.json`, {
                    params: {
                        limit: 200,
                        situacao: 0,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar familias.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.familiaList = response.data.content.map((p) => {
                            return {
                                id: p.idfamilia,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.familiaList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar Familias.', e);
                })
                .finally((_) => {
                    this.familiaLoading = false;
                });
        },
        updateFamilia(familia) {
            this.familiaSelected = familia;
            this.$emit('update-filtro', {
                nomeFiltro: 'idFamiliaList',
                valor:
                    this.familiaSelected.length == 0 ? [] : this.familiaSelected.map((p) => p.id),
            })
        },
        carregarGrupo(searchQuery) {
            this.grupoLoading = true;
            this.$axios
                .get(`/product/getcombo/group.json`, {
                    params: {
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar grupos.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.grupoList = response.data.content.map((p) => {
                            return {
                                id: p.idgrupoproduto,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.grupoList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar Grupos.', e);
                })
                .finally((_) => {
                    this.grupoLoading = false;
                });
        },
        updateGrupo(grupo) {
            this.grupoSelected = grupo;
            this.carregarSubGrupoProduto('.*', grupo);
            this.$emit('update-filtro', {
                nomeFiltro: 'idGrupoList',
                valor:
                    this.grupoSelected.length == 0 ? [] : this.grupoSelected.map((p) => p.id),
            })
        },
        carregarSubGrupoProduto(searchQuery, grupos = []) {
            this.subGrupoProdutoLoading = true;

            const gruposToFilter = grupos.map(grupo => grupo.id).join(', ')

            this.$axios
                .get(`/product/getcombo/subgroup.json`, {
                    params: {
                        page: 0,
                        limit: 200,
                        column: 'id',
                        order: 'desc',
                        grupoid: gruposToFilter || 0,
                        situacao: 1,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar subGrupoProdutos.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.subGrupoProdutoList = response.data.content.map((p) => {
                            return {
                                id: p.idsubgrupoproduto,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.subGrupoProdutoList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar SubGrupoProdutos.', e);
                })
                .finally((_) => {
                    this.subGrupoProdutoLoading = false;
                });
        },
        updateSubGrupoProduto(subGrupoProduto) {
            this.subGrupoProdutoSelected = subGrupoProduto;
            this.$emit('update-filtro', {
                nomeFiltro: 'idSubGrupoProdutoList',
                valor:
                    this.subGrupoProdutoSelected.length == 0 ? [] : this.subGrupoProdutoSelected.map((p) => p.id),
            })
        },
        carregarProduto(searchQuery) {
            this.produtoLoading = true;
            this.$axios
                .get(`/sales/package/product/findallcomboproduto.json`, {
                    params: {
                        limit: 200,
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar produtos.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.produtoList = response.data.content.map((p) => {
                            return {
                                id: p.idproduto,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.produtoList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar produtos.', e);
                })
                .finally((_) => {
                    this.produtoLoading = false;
                });
        },
        updateProduto(produto) {
            this.produtoSelected = produto;
            this.$emit('update-filtro', {
                nomeFiltro: 'idProdutoList',
                valor:
                    this.produtoSelected.length == 0 ? [] : this.produtoSelected.map((p) => p.id),
            })
        },
        carregarUnidadeMedida(searchQuery) {
            this.unidadeMedidaLoading = true;
            this.$axios
                .get(`/agro/unitmeasure.json`, {
                    params: {
                        page: 0,
                        limit: 200,
                        situacao: 1,
                        order: 'desc',
                        column: 'idunidademedida',
                        param: searchQuery
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[OBJETIVO DE VENDA] Erro status ${r.status} ao carregar unidadeMedidas.`);
                        console.error(`[OBJETIVO DE VENDA] Mensagem: ${r.message}`);
                    } else {
                        this.unidadeMedidaList = response.data.content.map((p) => {
                            return {
                                id: p.idunidademedida,
                                descricao: p.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.unidadeMedidaList = [];
                    console.error('[OBJETIVO DE VENDA] Erro ao carregar UnidadeMedidas.', e);
                })
                .finally((_) => {
                    this.unidadeMedidaLoading = false;
                });
        },
        updateUnidadeMedida(unidadeMedida) {
            this.unidadeMedidaSelected = unidadeMedida;
            this.$emit('update-filtro', {
                nomeFiltro: 'idUnidadeMedidaList',
                valor:
                    this.unidadeMedidaSelected.length == 0 ? [] : this.unidadeMedidaSelected.map((p) => p.id),
            })
        },
        clearFilter() {
            this.empresaSelected = [];
            this.clienteSelected = [];
            this.cidadeSelected = [];
            this.categoriaSelected = [];
            this.familiaSelected = [];
            this.grupoSelected = [];
            this.subGrupoProdutoSelected = [];
            this.produtoSelected = [];
            this.unidadeMedidaSelected = [];
        },
    }
}
</script>
